export const MenuItems = [
    {
        title: 'Home',
        id: 'home',
        cName: 'nav-links'
    },
    {
        title: 'About',
        id: 'about',
        cName: 'nav-links'
    },
    {
        title: 'Projects',
        id: 'projects',
        cName: 'nav-links'
    },
    {
        title: 'Contact Me',
        id: 'contact',
        cName: 'nav-links'
    },
]